import React, { useEffect, useState } from "react";

// Material Components
import { Divider } from "@mui/material";

// Common Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable/NoColumnTable";
import PageTitle from "examples/NewDesign/PageTitle";
import MDBox from "components/MDBox";
import FilterButton from "components/Buttons/FilterButton";
import BasicButton from "examples/NewDesign/CustomButton/BasicButton";

// Redux
import { useDispatch, useSelector } from "react-redux";
import getAllNotifications, {
  markAsRead,
  markAllAsRead,
  getPoperNotifications,
} from "redux/Thunks/Notification";
import { updateNotificationState, markAllNotificationasRead } from "redux/Slice/SystemNotification";

// Table Data
import NotificationData from "layouts/wfmwizard/Actions/data/notificationData";

// 3rd party library
import { Feature } from "flagged";

// Utils
import Constants, {
  Colors,
  defaultData,
  PageTitles,
  FeatureTags,
  ButtonTitles,
  Icons,
} from "utils/Constants";
import { paramCreater } from "utils/methods/methods";

function SystemNotification() {
  const dispatch = useDispatch();
  const notificationList = useSelector((state) => state.systemNotification);
  const { allNotifications = [], poperNotifications = [] } = useSelector(
    (state) => state.systemNotification
  );
  const [loading, setLoading] = useState(Constants.PENDING);
  const [tablePagination, setTablePagination] = useState({
    page: 0,
    perPage: defaultData.PER_PAGE,
  });

  const unReadNotification = poperNotifications?.filter((n) => !n.isRead);
  const handleMarkAllasRead = async () => {
    const res = await dispatch(markAllAsRead());
    if (res?.payload?.status === 200) {
      dispatch(markAllNotificationasRead());
    }
  };

  const getNotifications = async () => {
    setTablePagination({ ...tablePagination, page: 0 });
    const param = {
      page: 0,
      perPage: tablePagination.perPage,
    };
    setLoading(Constants.PENDING);
    await dispatch(getAllNotifications(paramCreater(param)));
    await dispatch(getPoperNotifications());
    setLoading(Constants.FULFILLED);
  };

  const handleTablePagination = async (value) => {
    if (notificationList.notificationListingPagiantion.completed.includes(value)) return;
    const paramData = {
      page: value,
      perPage: tablePagination.perPage,
    };
    Object.keys(paramData).forEach((key) => {
      if (paramData[key] === "") {
        delete paramData[key];
      }
    });

    const data = new URLSearchParams(paramData);
    setLoading(Constants.PENDING);
    await dispatch(getAllNotifications(data.toString()));
    setLoading(Constants.FULFILLED);
  };

  useEffect(() => {
    getNotifications();
  }, []);

  const handleMarkAsRead = async (id) => {
    const res = await dispatch(markAsRead({ id, isRead: true }));
    if (res?.payload?.status === 200) {
      dispatch(updateNotificationState(id));
    }
  };

  const handleReload = () => {
    getNotifications();
  };
  const { columns, rows } = NotificationData(allNotifications || [], handleMarkAsRead);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox display="flex" justifyContent="space-between">
        <PageTitle title={PageTitles.SYSTEM_NOTIFICATION} />
        <BasicButton
          icon={Icons.RELOAD}
          background={Colors.WHITE}
          border
          color={Colors.BLACK}
          action={handleReload}
        />
      </MDBox>
      <Divider sx={{ marginTop: 2 }} />
      <Feature name={FeatureTags.NOTIFICATION}>
        {allNotifications?.length > 0 && unReadNotification?.length > 0 && (
          <MDBox display="flex" justifyContent="flex-end">
            <FilterButton
              title={ButtonTitles.MARK_ALL_AS_READ}
              variant="none"
              color={Colors.PRIMARY}
              icon={Icons.ACCEPT3}
              handleClick={handleMarkAllasRead}
              mt={2}
            />
          </MDBox>
        )}
        <MDBox mt={2}>
          <DataTable
            table={{ columns, rows }}
            backgroundColor={Colors.White}
            isSorted={false}
            entriesPerPage={{ defaultValue: defaultData.PER_PAGE }}
            showTotalEntries={false}
            noEndBorder
            loading={loading}
            isColumn={false}
            currentPage={tablePagination.page}
            handleTablePagination={handleTablePagination}
            handleCurrentPage={(page) => setTablePagination({ ...tablePagination, page })}
            isGotoVisisble
          />
        </MDBox>
      </Feature>
    </DashboardLayout>
  );
}

export default SystemNotification;
